var gaSelectedFilters = function gaSelectedFilters(filters) {
  return filters && Array.isArray(filters) && filters.length ? filters.map(function (f) {
    return f.value;
  }).filter(Boolean).join('|') || undefined : undefined;
};
export default gaSelectedFilters;